import React, { useContext, useEffect, useState } from 'react';

import { LegacyContext } from '~/stormpath/components/LegacyContextType';
import { AuthContext } from '~/stormpath/components/Router';

import { Box, Container, Divider, Typography } from '@mui/material';

import { TryBetaButton } from './TryBetaButton';

export default function Footer() {
  const { user } = useContext<LegacyContext>(AuthContext);
  const isUnauthenticated = !user;
  const isCypressTest = typeof window !== 'undefined' && Boolean(window.Cypress);
  const [santaImages, setSantaImages] = useState<{
    login1?: string;
    login2?: string;
    login3?: string;
  }>({});

  useEffect(() => {
    if (isUnauthenticated && !isCypressTest) {
      // Lazy load the large GIF files only when needed (unauthenticated)
      Promise.all([
        import('~/assets/login-1.gif'),
        import('~/assets/login-2.gif'),
        import('~/assets/login-3.gif'),
      ]).then(([img1, img2, img3]) => {
        setSantaImages({
          login1: img1.default,
          login2: img2.default,
          login3: img3.default,
        });
      });
    }
  }, [isUnauthenticated, isCypressTest]);

  return (
    <Container maxWidth="xl" sx={{ position: 'relative' }}>
      <Divider sx={{ my: 2 }} />

      <Box mb={2} display="flex" justifyContent="space-between">
        <Box display="flex" gap={2}>
          <Typography color="secondary" variant="body2">
            &copy; 2017 - {new Date().getFullYear()}, Luxury Escapes
          </Typography>
          <Typography color="secondary" variant="body2">
            React: v{React.version}
          </Typography>
        </Box>
        <Box display="flex" alignItems="center" gap={1} mr={5}>
          <TryBetaButton />
        </Box>
      </Box>

      {/* Decorative images that sit on the top border of the footer without affecting layout height */}
      {isUnauthenticated && santaImages.login1 && santaImages.login2 && santaImages.login3 && (
        <Box
          data-testid="footer-christmas-decorations"
          sx={{
            position: 'absolute',
            bottom: '48%',
            left: '50%',
            transform: 'translateX(-50%)',
            display: 'flex',
            alignItems: 'flex-end',
            zIndex: 1,
            pointerEvents: 'none',
          }}
        >
          <Box
            component="img"
            src={santaImages.login1}
            alt="Christmas decoration 1"
            loading="lazy"
            sx={{ height: 'clamp(240px, 21vw, 420px)', width: 'auto', zIndex: 10, pointerEvents: 'none' }}
          />
          <Box
            sx={{
              position: 'relative',
              display: 'inline-flex',
              ml: { xs: '-6vw', sm: '-7vw', md: '-8vw', lg: '-9vw' },
              mr: { xs: '-5vw', sm: '-6vw', md: '-7vw', lg: '-8vw' },
              zIndex: 9,
            }}
          >
            <Box
              component="img"
              src={santaImages.login2}
              alt="Christmas decoration 2"
              loading="lazy"
              sx={{ height: 'clamp(270px, 27vw, 480px)', width: 'auto', ml: '-3vw', mr: '-3vw', pointerEvents: 'none' }}
            />
          </Box>
          <Box
            component="img"
            src={santaImages.login3}
            alt="Christmas decoration 3"
            loading="lazy"
            sx={{ height: 'clamp(210px, 20vw, 360px)', width: 'auto', zIndex: 10, pointerEvents: 'none' }}
          />
        </Box>
      )}
    </Container>
  );
}
